import { ProgressBar } from '@/src/elements/progress-bar'
import { colors } from '@/src/styles/colors'

export type TCommunityProgressBarProps = {
  progress: number | undefined
}

export const CommunityProgressBar = ({ progress }: TCommunityProgressBarProps) => {
  if (!progress) return null

  return (
    <ProgressBar
      fill={progress >= 100 ? colors.success['text-contrast-low'].DEFAULT : 'white'}
      progress={progress}
      className="w-full max-h-2 bg-white/25"
    />
  )
}
